import { render, staticRenderFns } from "./picker-aftersales.vue?vue&type=template&id=73226ece&"
import script from "./picker-aftersales.vue?vue&type=script&lang=js&"
export * from "./picker-aftersales.vue?vue&type=script&lang=js&"
import style0 from "./picker-aftersales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports